import { executeRequest, Request } from '@jfs/network'
import { RootStore } from '../../data/store'
import { getNetworkResponseError, getUTCTimeStamp, getUTCTimeStampp, isStatusOK } from '../../util/utill'
import { APIEndPoints } from '../APIEndPoints'
import { sitConfig } from '../config'
import { sendEventApi } from '../sendEvent'
const responseParser = (data: any) => {
  if (!data || (typeof data === 'string' && data.includes('<html>'))) {
    throw {
      message: 'Circle list service is temporarily unavailable.',
      code: 'SERVER_ERROR_500',
    }
  }
  if (isStatusOK(data) && data?.data?.responseStatus?.code === '000') {
    console.log('data at try block in responseParser getCircleListBCApi', data)
    return data.data.responseObject
  } else {
    console.log('data at catch block in responseParser getCircleListBCApi', data.data)
    // throw getNetworkResponseError(data?.data)
    const errorBody = data?.data || data || { message: 'Unable to fetch circle list' }
    console.log('Error encountered in getCircleList parser:', errorBody)

    // Pass a safe object to the restricted util
    throw getNetworkResponseError(errorBody)
  }
}
export const getCircleListBCApi = (tokens: any, body: any) => {
  let config = sitConfig(tokens) as any
  config.headers['x-user-access-token'] = RootStore?.bcAppInfo?.userAccessToken
  config.headers['x-userid-token'] = RootStore?.bcAppInfo?.userIdentifier
  config.headers['x-jfsUserId'] = RootStore.BillPaymentAgentOnboard.tempCustomerData?.jfsUserId || '1972283249505670348'
  config.headers['x-mobileNumber'] = RootStore.BillPaymentAgentOnboard.tempCustomerData?.mobileNumber || 'N/A'
  config.headers['x-channelId'] = RootStore.agent.session.CHANNEL_ID || '3155'
  config.headers['x-channel-user-id'] =
    RootStore.BillPaymentAgentOnboard.tempCustomerData?.jfsUserId || '1123766817865366323'
  config.headers['x-intercept-gateway'] = 'SERVICE/JPB'

  const requestBody = {
    domain: {
      id: 'PayMyBill',
      name: 'PayMyBill',
      transactionType: 'BUY',
      description: 'Fetch favorite transactions',
    },
    initiatingEntity: {
      entityId: RootStore.agent.session.CHANNEL_ID || '',
      channelId: RootStore.agent.session.CHANNEL_ID || '',
      returnUrl: null,
      callbackUrl: null,
    },
    ...body,
    customerDetails: {
      jpbUserId: RootStore.BillPaymentAgentOnboard.tempCustomerData?.jfsUserId || '',
      agentId: RootStore.agent.agentInfo.agentUserLoginId,
    },
    config: {
      orderHistoryStartDate: getUTCTimeStampp({ daysAgo: 30 }),
      orderHistoryEndDate: getUTCTimeStamp(),
      limit: '10',
      offset: '0',
    },
  }

  const request: Request<{}> = {
    apiPath: APIEndPoints.getCircleList,
    method: 'POST',
    config: config,
    body: requestBody,
  }
  sendEventApi(tokens, request, {
    status: 'INITIATED',
  })
  return executeRequest(request)
    .then((data) => {
      console.log(data, 'Akanksha see what data we are sending to getCircleList response parser')
      console.log('requestBody in getCircleList', requestBody)
      return responseParser(data)
    })
    .then((response) => {
      sendEventApi(tokens, request, {
        status: 'SUCCESS',
      })
      return response
    })
    .catch((err) => {
      sendEventApi(tokens, request, {
        status: 'FAILED',
        errorDescription: err,
      })
      throw err
    })
}
